import script from "./DeadlineCameras.vue?vue&type=script&setup=true&lang=js"
export * from "./DeadlineCameras.vue?vue&type=script&setup=true&lang=js"

import "./DeadlineCameras.vue?vue&type=style&index=0&id=53254ce7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53254ce7"]])

export default __exports__